import React, { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import SkillSection from './SkillSection';
import ProjectsSection from './ProjectsSection';
import ContactSection from './ContactSection';

const HomePage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FDFAED' }}>
      <HeroSection />
      <SkillSection />
      <ProjectsSection />
      <ContactSection />
    </div>
  );
};

export default HomePage;